var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TablePublic',{attrs:{"colLists":_vm.weightDetailColLists,"tableData":_vm.data,"paginationFlag":false,"summary":"","summary-method":_vm.weightDetailSummaryMethod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }